export default "__VITE_ASSET__CEDtVUwl__"